<template>
  <div style="background-color: #fff">
    <div class="fincal-content">
      <p class="" style="margin-top: 5%">
        <span>Category</span>
      </p>
      <h1 class="pageshead">Company News & Blogs</h1>
      <div class="nextewnzheng" @click="gotoarticle('evolution')">
        <div class="nectar-video-inner nectar-video-innertwo">
          <div
            class="row-bg-overlay row-bg-layertwo"
            style="background-color: #000000; opacity: 0.3"
          ></div>

          <div class="video-content">
            <div class="video-content-left" style="top: 33%">
              <div class="huibutton">Company News & Blogs</div>
              <h3 style="color: #fff; width: 60%">
           The Evolution of Business Intelligence: From Reporting to Predictive Analytics
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-center">
        <div class="nextewnzheng" @click="gotoarticle('choosing')">
          <div
            class="nectar-video-inner nectar-video-innertwo nectar-video-legal"
          >
            <div
              class="row-bg-overlay row-bg-layertwo"
              style="background-color: #000000; opacity: 0.3"
            ></div>

            <div class="video-content">
              <div class="video-content-left" style="top: 33%">
                <div class="huibutton">Company News & Blogs</div>
                <h3 style="color: #fff; width: 90%">
               Choosing the Right Business Intelligence Tools for Your Organization
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="nextewnzheng" @click="gotoarticle('trends')">
          <div
            class="nectar-video-inner nectar-video-innertwo nectar-video-business"
          >
            <div
              class="row-bg-overlay row-bg-layertwo"
              style="background-color: #000000; opacity: 0.3"
            ></div>

            <div class="video-content">
              <div class="video-content-left" style="top: 33%">
                <div class="huibutton">Company News & Blogs</div>
                <h3 style="color: #fff; width: 90%">
              Key Trends Shaping the Landscape of Business Intelligence in 2024
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

     
      <div class="next">
        <span class="next-noactive" @click="gotoarticle('companypages')">
            1
        </span>
          <span class="next-noactive" @click="gotoarticle('companypagestwo')">2</span>
            <span class="next-page">3</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Products",
  data() {
    return {};
  },
  watch: {
    //   '$route.hash': function() {
    //     // 在这里可以处理hash变化后的逻辑
    //   this.scrollToAnchor()
    //   }
  },
  methods: {
    //  scrollToAnc
    gotoarticle(route) {
      console.log(route);
      this.$router.push({ name: route });
      // window.location.hash = "#about#top";
    },
    //   const el = document.querySelector(this.$route.hash);
    //   el.scrollIntoView({ behavior: "smooth" });
    // },
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.scrollToAnchor()
  },
};
</script>

<style scoped>
ol,
ul {
  margin-left: 30px;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.focus {
  position: relative;
}
h2 {
  font-family: Alegreya Sans;
  font-size: 46px;
  line-height: 56px;
  font-weight: 500;
  margin: 7px 0px;
}

head {
}
h3 {
  font-family: Alegreya Sans;
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
  /* color: #3d7cbf; */
  text-align: left;
  margin-bottom: 8px;
  margin-top: 10px;
}
.nectar-video-bg {
  height: 100%;
  position: relative;
  top: -25%;
}
.Financial-text {
  padding: 0 20px;
  border-left: 1px solid #ccc;
  color: #fff;
}
.fincalrouter {
  color: #1290c9;
}
.fincal-content {
  margin: auto;
  width: 88%;
  padding: 80px 0px;
  font-size: 18px;
}
.fincal-head {
  padding-bottom: 27px;
}
.fincal-wenzi {
   font-family: "Roboto" !important;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
}
.wenzhang {
  color: #fff;
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  width: 200px;
  margin: auto;
  margin-top: -50px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.wenzhangtwo {
  color: #fff;
  padding: 6px;
  font-size: 18px;
  margin: auto;
}
.nectar-video-innertwo {
  height: 290px;
  background-image: url("../assets/2024/01/how-to-become-a-business-intelligence-analyst.jpg");
  background-position-y: 431px;
  transition: transform 0.42s ease;
  background-size: 100%;
  position: relative;
}
.nectar-video-legal {
  background-image: url("../assets/2024/01/download-1.jpeg");
  background-position-y: 0px;
}
.nectar-video-business {
  background-image: url("../assets/2024/01/bi-business-intelligence-ts-100646689-orig-4.webp");
  background-position-y: 0px;
  background-size: 100%;
}


.nextewnzheng {
  overflow: hidden;
  width: 65%;
}
.nextewnzheng {
  transition: transform 0.42s ease;
}

.nextewnzheng:hover .nectar-video-innertwo {
  cursor: pointer;
  transform: scale(1.1);
  transition: transform 0.42s ease;
}
.nextewnzheng :hover .row-bg-layertwo {
  opacity: 0.1 !important;
}
@media screen and (max-width: 500px) {
  .video-content-title {
    font-size: 51px;
  }
    .nextewnzheng{
    width: 100% !important;
  }
  .video-content-left h3{
    width: 100% !important;
  }
  .flex-center{
   flex-wrap: wrap !important;
   width: 100% !important;
  }

    h3{
      font-size: 23px !important;
    }
    .pageshead {
      font-size: 53px !important;
      line-height: 52px !important;
    }
}
.pageshead {
  font-family: Alegreya Sans;
  font-size: 82px;
  line-height: 92px;
  font-weight: 500;
  padding-bottom: 36px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 40px;
}
.video-content-left {
  position: absolute;
  top: 49%;
  left: 6%;
}
.flex-center {
  display: flex;
  justify-content: space-between;
  width: 65%;
}
.flex-center .nextewnzheng {
  width: 49%;
  margin: 20px 0px;
}
.next-noactive{
    padding: 20px;
}
.next-page{
       padding: 8px 10px;
       background-color: #1290c9 ;
       border-radius: 5px;
       color: #fff;
         cursor: pointer;
}
.next{
    padding: 50px;
      cursor: pointer;
}
</style>